/*
  Sleep Blend landing page.
  Generates the hero starfield. Scoped to [data-sb-sky] so it cannot
  touch anything else on the page. Plain ES5 + defer, matching the
  other campaign assets in this theme.
*/
(function () {
  'use strict';

  function buildStars(sky) {
    if (sky.dataset.sbSkyReady === 'true') return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var count = parseInt(sky.dataset.sbSky, 10) || 24;

    // Optional per-field tuning. Defaults reproduce the original hero sky:
    // stars 0.9-3.1px, roughly one in five twinkling.
    var minSize = parseFloat(sky.dataset.sbSizeMin);
    if (isNaN(minSize)) minSize = 0.9;
    var maxSize = parseFloat(sky.dataset.sbSize);
    if (isNaN(maxSize)) maxSize = 3.1;
    var twinkleAbove = parseFloat(sky.dataset.sbTwinkle);
    if (isNaN(twinkleAbove)) twinkleAbove = 0.82;

    var sizeRange = Math.max(maxSize - minSize, 0);
    var html = '';

    for (var i = 0; i < count; i++) {
      var size = (Math.random() * sizeRange + minSize).toFixed(2);
      var x = (Math.random() * 100).toFixed(2);
      var y = (Math.random() * 100).toFixed(2);
      var opacity = (Math.random() * 0.55 + 0.28).toFixed(2);
      var twinkle = !reduce && Math.random() >= twinkleAbove;

      html +=
        '<i class="sb-star' + (twinkle ? ' sb-twinkle' : '') + '"' +
        ' style="width:' + size + 'px;height:' + size + 'px;' +
        'left:' + x + '%;top:' + y + '%;opacity:' + opacity +
        (twinkle ? ';animation-delay:' + (Math.random() * 5).toFixed(2) + 's' : '') +
        '"></i>';
    }

    sky.innerHTML = html;
    sky.dataset.sbSkyReady = 'true';
  }

  // Phone menu: the hamburger toggles the dropdown; picking a link, pressing
  // Escape, tapping outside, or widening past 750px closes it again.
  function bindMenu(toggle) {
    if (toggle.dataset.sbNavReady === 'true') return;
    toggle.dataset.sbNavReady = 'true';

    var menu = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!menu) return;

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      menu.hidden = !open;
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hidden) {
        setOpen(false);
        toggle.focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (!menu.hidden && !menu.contains(event.target) && !toggle.contains(event.target)) setOpen(false);
    });
    window.matchMedia('(min-width: 751px)').addEventListener('change', function (event) {
      if (event.matches) setOpen(false);
    });
  }

  // Floating CTA: hidden while the hero is on screen, shown once the page has
  // scrolled past it, and hidden again while the plans section (the CTA's own
  // target) is on screen. While hidden it is also removed from the tab order.
  function bindStickyCta(cta) {
    if (cta.dataset.sbStickyReady === 'true') return;
    cta.dataset.sbStickyReady = 'true';

    var hero = document.getElementById('sb-top');
    var plans = document.querySelector('.sb-plans');
    var link = cta.querySelector('a');
    var pastHero = false;
    var plansInView = false;

    function setVisible(visible) {
      cta.classList.toggle('is-visible', visible);
      cta.setAttribute('aria-hidden', String(!visible));
      if (link) link.tabIndex = visible ? 0 : -1;
      document.documentElement.classList.toggle('sb-sticky-cta-on', visible);
    }

    if (!hero || !('IntersectionObserver' in window)) {
      setVisible(true);
      return;
    }

    function update() {
      setVisible(pastHero && !plansInView);
    }

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      // Only after the hero has left through the top, not before it arrives.
      pastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    }).observe(hero);

    if (plans) {
      new IntersectionObserver(function (entries) {
        plansInView = entries[0].isIntersecting;
        update();
      }).observe(plans);
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-sb-sky]').forEach(buildStars);
    (root || document).querySelectorAll('[data-sb-nav-toggle]').forEach(bindMenu);
    (root || document).querySelectorAll('[data-sb-sticky-cta]').forEach(bindStickyCta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-run when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
